// extracted by mini-css-extract-plugin
export default {"comment":"dbecf7f32ef09fb8","commentType":"d420f861b465dba7"};